import { useQuery } from '@tanstack/react-query';
import { fetchHillCountry } from '../api/hillCountry';

/** Hill Country basins, fetched the first time the layer is turned on and kept for the session. */
export function useHillCountryQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['hill-country'],
    queryFn: ({ signal }) => fetchHillCountry(signal),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    enabled,
  });
}
